<template>
  <div class="basic_wrap">
    <van-nav-bar
      safe-area-inset-top
      fixed
      :title="$t('lh.量化')"
      left-arrow
      @click-left="$router.back()"
    />

    <div class="box">
      <div class="top">
        <div class="top-1">
          <div class="items-center">
            <img class="icon" src="../../assets/images/vip.png" alt="">
            <span class="vip">VIP {{ userInfo.vip_name }}</span>
          </div>
          <div>
            <van-button block size="small" plain @click="$router.push('/invest')">{{ $t("user.recharge") }}</van-button>
          </div>
        </div>
        <div class="top-title">{{ $t('lh.您当前日收益率为') }}</div>
        <div class="top-title">{{ info.incomeRate }}%</div>
        <div class="top-title">{{ $t('lh.最低收益需至少存入') }}{{ info.investMoney }}</div>
      </div>

      <div class="mt-4">
        <van-button block size="small" color="#425b8d"  v-if="info.num > 0" @click="submit">{{ $t("lh.立即量化") }}</van-button>
        <van-button block size="small" color="#425b8d" v-else disabled>{{ $t("lh.暂无量化权限") }}</van-button>
      </div>

      <div class="tips">{{ $t("lh.今日剩余量化交易次数") }} : {{ info.num }}</div>
      <div class="tips">{{ $t("lh.量化时间") }}</div>

      <div class="list">
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          :pulling-text="$t('common.下拉刷新')"
          :loosing-text="$t('common.释放刷新')"
          :loading-text="$t('common.加载中')"
        >
          <div class="px-2">
            <van-list
              v-model:loading="loading"
              :finished="finished"
              :loading-text="$t('common.加载中')"
              :finished-text="$t('common.没有更多了')"
              :error-text="$t('common.加载失败')"
              @load="onLoad"
            >

              <div class="box-1" v-for="item in list" :key="item.id">
                <div>{{ item.name }}</div>
                <div class="grid-box">
                  <div>{{ $t("lh.金额") }}: {{ parseInt(item.position) }}</div>
                  <div>{{ $t("lh.利润") }}: <span class="text-[#1989fa]">+{{ parseInt(item.income) }}</span></div>
                  <div>{{ $t("lh.收益率") }}: {{ item.platform }}%</div>
                  <div>{{ $t("lh.剩余次数") }}: {{ parseInt(item.buy_price) }}</div>
                </div>
                <div class="timer text-gray-500">{{ item.create_time }}</div>
              </div>
            </van-list>
          </div>
        </van-pull-refresh>
      </div>

    </div>
  </div>
</template>

<script>
import Fetch from '@/utils/fetch';
import router from '@/router';

export default {
    name: "quantify",
    data() {
        return {
            page: 1,
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
	        
	        userInfo:{},
	        info:{},
        }
    },
    created() {
		this.getUserInfo();
		this.getUserVipInfo();
        this.$parent.footer('quantify')
    },
    methods: {
	    router() {
		    return router
	    },
        onRefresh() {
			this.page = 1;
			this.list = [];
			this.finished = false;
			this.loading = true;
			this.onLoad();
        },
        onLoad() {
            Fetch('/user/quantityLogs', {page: this.page}).then(res => {
	            this.list.push(...res.data.list);
	            this.loading = false;
	            this.refreshing = false;
				if(this.list.length >= res.data.total){
					this.finished = true
				}
            })
        },
	    getUserVipInfo(){
			Fetch('/user/getUserVipInfo').then(res => {
				this.info = res.data
			})
	    },
	    getUserInfo(){
		    Fetch('/user/info').then((r) => {
			    this.userInfo = r.data;
		    });
	    },
	    
	    submit(){
			Fetch('/user/buyQuantify').then(r => {
				this.getUserVipInfo();
				this.onRefresh();
			})
	    },

    }
}
</script>

<style scoped lang="less">
.mt-4 {
  margin: 1rem 0;
}

.items-center {
  display: flex;
  align-items: center;
}
.list{
	padding: 0 1rem;
}
.box-1 {
	margin-top: 1rem;
	margin-bottom: 1rem;
	border-radius: 0.25rem;
	padding: 1rem;
	color: #FFFFFF;
	border: 1px solid #3b3b3b;
	
	.grid-box{
		//grid grid-cols-2 gap-y-2 mt-2 text-xs
		display: grid;
		row-gap: 0.5rem;
		grid-template-columns: repeat(2,minmax(0,1fr));
		margin-top: 0.5rem;
		font-size: .75rem;
		line-height: 1rem;
	}
	
	.timer{
		margin-top: 0.5rem;
		font-size: 2.67vw;
		opacity: 1;
		color: rgb(107 114 128 / 1);
	}
}
.tips {
  text-align: center;
  color: #aeb5c3;
  margin: 10px 0;
  font-size: .8rem;
}

.top {
  border-radius: 12px;
  background: url("../../assets/images/mining.jpg") no-repeat;
  background-size: 100% 100%;
  height: 8rem;
  padding: 1rem;
  color: #FFFFFF;

  .top-title {
    font-size: .7rem;
    margin: 10px 0;
  }

  .top-1 {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon {
      width: 20px;
    }

    .vip {
      display: inline-block;
      padding-left: 6px;
      font-size: 14px;
      font-weight: 600;
    }
  }


}


/deep/ .van-nav-bar {
  color: rgb(239, 216, 196);
  background-color: rgb(35, 29, 29);
}

/deep/ .van-nav-bar__title {
  color: rgb(239, 216, 196);
}

/deep/ .van-nav-bar .van-icon {
  color: rgb(239, 216, 196);
}

.basic_wrap {
  padding-top: 46px;
  display: flex;
  height: 100vh;
  box-sizing: border-box;
  flex-direction: column;

  .box {
    //overflow: hidden;
    flex: 1;
    background: url(../../assets/img/home-bg.jpg) no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: .3rem
  }
}
</style>
